import { render, staticRenderFns } from "./AccountTabs.vue?vue&type=template&id=08104097&"
import script from "./AccountTabs.vue?vue&type=script&lang=js&"
export * from "./AccountTabs.vue?vue&type=script&lang=js&"
import style0 from "./AccountTabs.vue?vue&type=style&index=0&id=08104097&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports